import React from 'react';
import ContentLoader from 'react-content-loader';

import { urlScisRedirect } from '../../settings';

class _SCISRedirection extends React.Component {
    componentDidMount() {
        window.location.replace(urlScisRedirect);
    }
    render() {
        return <Loading />;
    }
}

export const Loading = (props) => {
    return (
        <ContentLoader
            speed={2}
            width={'100%'}
            height={'90%'}
            backgroundColor='#e6e6e6'
            foregroundColor='#d8d8d8'
            {...props}
        >
            <rect x='40px' y='20px' rx='8px' ry='8px' width='calc(100% - 80px)' height='15%' />
            <rect x='40px' y='22%' rx='8px' ry='8px' width='70%' height='calc(100% - 40px)' />
            <rect x='74%' y='22%' rx='8px' ry='8px' width='calc(26% - 40px)' height='calc(100% - 20px)' />
        </ContentLoader>
    );
};

export default _SCISRedirection;



// WEBPACK FOOTER //
// ./src/components/SCISRedirection/index.js